import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Cookies from 'js-cookie';
import i18n from 'i18next';
import { isMobile } from 'react-device-detect';
import useDatalayerEvents from '../../hooks/useDatalayerEvents';
import useSessionChecking from '../../hooks/useSessionChecking';
import { BackMappings } from '../../utils/BackMappings';
import { GtmConstants } from '../../utils/GtmConstants';
import { StorageHelper } from '../../utils/StorageHelper';
import NotFound from '../NotFound';
import ValesCaprabo from './indexCaprabo';
import ValesEroski from './indexEroski';
import { MisValesAhorroService } from '../../services';
import useAPIError from '../../hooks/useAPIError';
import { ValesHelper } from './ValesHelper';
import { useAuthStore } from '../../store/AuthContext';
import { MocksHelper } from '../../services/mocks/MocksHelper';
import { ValesData } from '../../types/Types';
import { HostProvider } from '../../utils/HostProvider';
import routerLoader from '../../i18n/router';
import { FrontMappings } from '../../utils/FrontMappings';
import { useAppStore } from '../../store/AppContext';
import { ValeProvider } from './context/Vale.context';
import { FiltersConstants } from '../../utils/FiltersConstants';

const Vales: FC = () => {
  const isCaprabo = HostProvider.isCaprabo();
  const isEroski = HostProvider.isEroski();
  const [goOn, setGoOn] = useState<boolean>(false);
  StorageHelper.setOrigin(BackMappings.VALES);
  useSessionChecking(BackMappings.VALES, setGoOn, goOn);
  useDatalayerEvents(GtmConstants.MIS_VENTAJAS);

  const { t } = useTranslation();

  const dataUser = useAuthStore();
  const [valesData, setValesData] = useState<ValesData[]>([]);
  const [valesNoAct, setValesNoAct] = useState<ValesData[]>([]);
  const [valesPreAct, setValesPreAct] = useState<ValesData[]>([]);
  const [valesAct, setValesAct] = useState<ValesData[]>([]);
  const [valesCanj, setValesCanj] = useState<ValesData[]>([]);
  const [load, setLoad] = useState(false as boolean);
  const [existVales, setExistVales] = useState(false as boolean);
  const [view, setView] = useState(false as boolean);
  const [hayVales, setHayVales] = useState(true as boolean);
  const { addError, addErrorBack } = useAPIError();
  const [firstCharge, setFirstCharge] = useState(true);
  const [filtrosProductos, setFiltrosProductos] = useState<string[]>([]);
  const [filtrosOtros, setFiltrosOtros] = useState<string[]>([]);
  const [filtrosOtrosVisibles, setFiltrosOtrosVisibles] = useState<string[]>(
    [],
  );
  // TODO: isFiltroSoportePostalVisible, para probar en PREPRO y dejar visible el soporte postal en los filtros, cambiar a false antes de subir a produccion
  const [isFiltroSoportePostalVisible] = useState(
    FiltersConstants.IS_SOPORTE_POSTAL_VISIBLE as boolean,
  );

  const userToken = Cookies.get('token');
  sessionStorage.setItem('numCuponesAct', '0');
  sessionStorage.setItem('showCuponesAct', '0');
  const isApp = dataUser.user.isApp === 'true';
  const isAppOrMobile = isApp || isMobile;
  const dataApp = useAppStore();
  const urlMisDatos = routerLoader.LoadRouterByPath(
    FrontMappings.MISDATOS,
    dataApp.lang,
  );
  const urlScrollPreferencia = urlMisDatos
    .concat('?')
    .concat('irPreferencia=1');

  const retrieveValesAhorro = () => {
    setExistVales(false);
    const data = {
      token: userToken,
    };

    MisValesAhorroService.retrieveValesAhorro(data)
      .then((response) => {
        if (response.data.error === true) {
          if (firstCharge) {
            addError(t('nlr-vaya-algo-no-ha-ido-bien'), 'KO');
          }
          setHayVales(false);
          setView(true);
          addErrorBack(response.data);
        } else {
          setView(true);
          if (
            typeof response.data.pojos !== 'undefined' &&
            response.data.pojos != null &&
            response.data.pojos.length > 0
          ) {
            MocksHelper.adjustArrayToTriggerState(valesData, setValesData);
            setValesData(response.data.pojos);
          } else {
            setHayVales(false);
          }
        }
        setFirstCharge(false);
      })
      .catch((e) => {
        console.log(e);
        addError(t('nlr-vaya-algo-no-ha-ido-bien'), 'KO');
      });
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (dataUser.user.token !== '') {
      if (!load) {
        setLoad(true);
        retrieveValesAhorro();
      }
    }
  });

  const valesHelper = new ValesHelper(
    valesNoAct.length,
    valesAct.length,
    valesCanj.length,
    valesPreAct.length,
    null,
    null,
    null,
  );
  const handleVerMasClick = (e: any) => {
    valesHelper.handleVerMasClick(e);
  };

  function getSoportePostalByCodigoUrl(codigoSoportePostal) {
    let denominacionSoportePostal = '';
    if (
      codigoSoportePostal > 0 &&
      codigoSoportePostal < FiltersConstants.FILTROS_OTROS_SOPORTE_POSTAL.length
    ) {
      denominacionSoportePostal =
        FiltersConstants.FILTROS_OTROS_SOPORTE_POSTAL[codigoSoportePostal]
          .denominacion;
    }
    return denominacionSoportePostal;
  }
  function getPlanAdhesionByCodigoUrl(codigoPlanAdhesion) {
    let denominacionPlanAdhesion = '';
    if (
      codigoPlanAdhesion > 0 &&
      codigoPlanAdhesion < FiltersConstants.FILTROS_OTROS_PLAN_ADHESION.length
    ) {
      denominacionPlanAdhesion =
        FiltersConstants.FILTROS_OTROS_PLAN_ADHESION[codigoPlanAdhesion]
          .denominacion;
    }
    return denominacionPlanAdhesion;
  }

  function addPlanAdhesion(
    planAdhesion: number,
    denominacionPlanAdhesion: string,
    filtrosOtrosInicio: string[],
    filtrosOtrosAMostrar: string[],
  ) {
    if (
      planAdhesion !== null &&
      planAdhesion !== 0 &&
      FiltersConstants.FILTROS_OTROS_PLAN_ADHESION[0].denominacion !==
        denominacionPlanAdhesion &&
      denominacionPlanAdhesion.trim() !== '' &&
      !filtrosOtrosInicio.includes(denominacionPlanAdhesion)
    ) {
      filtrosOtrosInicio.push(denominacionPlanAdhesion);
      if (!filtrosOtrosAMostrar.includes(denominacionPlanAdhesion)) {
        filtrosOtrosAMostrar.push(denominacionPlanAdhesion);
      }
    }
  }

  function addSoportePostal(
    soportePostal: number,
    denominacionSoportePostal: string,
    filtrosOtrosInicio: string[],
    filtrosOtrosAMostrar: string[],
  ) {
    if (
      soportePostal !== null &&
      soportePostal !== 0 &&
      FiltersConstants.FILTROS_OTROS_SOPORTE_POSTAL[0].denominacion !==
        denominacionSoportePostal &&
      denominacionSoportePostal.trim() !== '' &&
      !filtrosOtrosInicio.includes(denominacionSoportePostal)
    ) {
      filtrosOtrosInicio.push(denominacionSoportePostal);
      if (
        FiltersConstants.IS_SOPORTE_POSTAL_VISIBLE &&
        !filtrosOtrosAMostrar.includes(denominacionSoportePostal)
      ) {
        filtrosOtrosAMostrar.push(denominacionSoportePostal);
      }
    }
  }

  function setDenominacionesFiltroOtros(
    valeVisible: ValesData,
    filtrosOtrosInicio: string[],
    filtrosOtrosAMostrar: string[],
  ) {
    const {
      denominacionPlanAdhesion,
      planAdhesion,
      denominacionSoportePostal,
      soportePostal,
    } = valeVisible;
    addPlanAdhesion(
      planAdhesion,
      denominacionPlanAdhesion,
      filtrosOtrosInicio,
      filtrosOtrosAMostrar,
    );
    addSoportePostal(
      soportePostal,
      denominacionSoportePostal,
      filtrosOtrosInicio,
      filtrosOtrosAMostrar,
    );
  }

  function setSeccionFiltroProductos(
    valeVisible: ValesData,
    filtrosProductosInicio: string[],
  ) {
    const { estructurasComerciales } = valeVisible;
    let j = 0;
    while (j < estructurasComerciales?.length) {
      const { seccion } = estructurasComerciales[j];
      if (
        seccion != null &&
        seccion !== 'null' &&
        seccion.trim() !== '' &&
        seccion !== '0' &&
        seccion.toUpperCase().trim() !==
          FiltersConstants.PRODUCTOS_TOTAL_ESTRUCTURA
      ) {
        if (!filtrosProductosInicio.includes(seccion)) {
          filtrosProductosInicio.push(seccion);
        }
        j = estructurasComerciales.length;
      } else {
        j += 1;
      }
    }
  }

  function setFiltrosOtrosUrlByCodigoDenominacion() {
    const filtrosOtrosInicioByURL: string[] = [];
    // TODO: RECOGER DE LA URL EL CODIGO de la DENOMINACION PARA FILTRAR POR URL Y SI EXISTE CAMBIAR A TRUE filtradoURL y filtrar segun codigo de la URL
    const codigoUrlSoportePostal = 0;
    const codigoUrlPlanAdhesion = 0;
    const denominacionSPByUrl: string = getSoportePostalByCodigoUrl(
      codigoUrlSoportePostal,
    );
    if (denominacionSPByUrl !== null && denominacionSPByUrl.length > 0) {
      if (!filtrosOtrosInicioByURL.includes(denominacionSPByUrl)) {
        filtrosOtrosInicioByURL.push(denominacionSPByUrl);
      }
      // TOPO: filtrado por URL --> activar filtro URL SOPORTE POSTAL
    }
    const denominacionPAByUrl = getPlanAdhesionByCodigoUrl(
      codigoUrlPlanAdhesion,
    );
    if (denominacionPAByUrl !== null && denominacionPAByUrl.length > 0) {
      if (!filtrosOtrosInicioByURL.includes(denominacionPAByUrl)) {
        filtrosOtrosInicioByURL.push(denominacionPAByUrl);
      }
    }
    setFiltrosOtros(filtrosOtrosInicioByURL);
  }

  function cargarFiltros(cuponesVisiualizables: ValesData[]) {
    if (cuponesVisiualizables.length > 0) {
      setExistVales(true);
    }
    const filtrosProductosInicio: string[] = [];
    const filtrosOtrosInicio: string[] = [];
    const filtrosOtrosAMostrar: string[] = [];
    // TODO: cambiar filtradoURL al recibir el codigo para filtrar los cupones POR SOPORTE POSTAL
    const filtradoURL = false;
    let i = 0;
    while (i < cuponesVisiualizables.length) {
      setSeccionFiltroProductos(
        cuponesVisiualizables[i],
        filtrosProductosInicio,
      );
      setDenominacionesFiltroOtros(
        cuponesVisiualizables[i],
        filtrosOtrosInicio,
        filtrosOtrosAMostrar,
      );
      i += 1;
    }
    if (filtrosProductosInicio.length > 0) {
      filtrosProductosInicio.sort();
      setFiltrosProductos(filtrosProductosInicio);
    }
    if (filtrosOtrosInicio.length > 0) {
      filtrosOtrosInicio.sort();
      setFiltrosOtros(filtrosOtrosInicio);
      if (filtrosOtrosAMostrar.length > 0) {
        filtrosOtrosAMostrar.sort();
        setFiltrosOtrosVisibles(filtrosOtrosAMostrar);
      }
    }
    if (filtradoURL) {
      // TODO: setFiltrosOtros ELRECIBIDO POR url DEL FILTRO DE SOPORTE POSTAL, ESTOS NO SE AGREGAN setFiltrosOtrosVisibles()
      setFiltrosOtrosUrlByCodigoDenominacion();
    }
  }

  useEffect(() => {
    const valesNoActivos = valesData.filter((v) => v.tipoLista === 1);
    const valesPreActivos = valesData.filter(
      (v) => v.tipoLista === 4 && !v.exclusividad,
    );
    const valesAllPreActivos = valesData
      .filter((v) => v.tipoLista === 4 && v.exclusividad)
      .map((e) => {
        e.tipoLista = 2;
        return e;
      });
    const valesActivos = valesData.filter((v) => v.tipoLista === 2);
    const valesCanjeados = valesData.filter((v) => v.tipoLista === 3);
    valesActivos.push(...valesAllPreActivos);

    setValesNoAct(valesNoActivos);
    setValesPreAct(valesPreActivos.slice(0, 2));
    setValesAct(valesActivos);
    setValesCanj(valesCanjeados);
    const valesVisualizables: ValesData[] = [
      ...valesNoActivos,
      ...valesPreActivos,
      ...valesActivos,
      ...valesCanjeados,
    ];
    cargarFiltros(valesVisualizables);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [valesData]);

  const defaultLang: string | undefined = Cookies.get('i18next');
  const currentPath = window.location.pathname;
  if (
    typeof defaultLang !== 'undefined' &&
    `${defaultLang}/vales` === currentPath
  ) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    // @ts-ignore
    document.querySelector('span.num-alert').classList.add('display-none');
    // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    // @ts-ignore
    document.getElementById('notificaciones').classList.add('notif-active');
  }

  useEffect(() => {
    if (dataUser.user.token !== '') {
      retrieveValesAhorro();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n.language]);

  if (goOn) {
    if (view) {
      if (isEroski) {
        return (
          <ValeProvider>
            <ValesEroski
              filtrosProductos={filtrosProductos}
              filtrosOtros={filtrosOtros}
              isFiltrosSoportePostalVisible={isFiltroSoportePostalVisible}
              isApp={isApp}
              hayVales={hayVales}
              view={view}
              valesNoAct={valesNoAct}
              retrieveValesAhorro={retrieveValesAhorro}
              isMobile={isAppOrMobile}
              handleVerMasClick={handleVerMasClick}
              valesAct={valesAct}
              valesPreAct={valesPreAct}
              valesCanj={valesCanj}
              existVales={existVales}
              urlMDScrollPreferencia={urlScrollPreferencia}
              filtrosVisiblesProductos={filtrosProductos}
              filtrosVisiblesOtros={filtrosOtrosVisibles}
            />
          </ValeProvider>
        );
      }
      if (isCaprabo) {
        return (
          <ValeProvider>
            <ValesCaprabo
              filtrosProductos={filtrosProductos}
              filtrosOtros={filtrosOtros}
              isFiltrosSoportePostalVisible={isFiltroSoportePostalVisible}
              isApp={isApp}
              hayVales={hayVales}
              view={view}
              valesNoAct={valesNoAct}
              retrieveValesAhorro={retrieveValesAhorro}
              isMobile={isAppOrMobile}
              handleVerMasClick={handleVerMasClick}
              valesAct={valesAct}
              valesPreAct={valesPreAct}
              valesCanj={valesCanj}
              existVales={existVales}
              urlMDScrollPreferencia={urlScrollPreferencia}
              filtrosVisiblesProductos={filtrosProductos}
              filtrosVisiblesOtros={filtrosOtrosVisibles}
            />
          </ValeProvider>
        );
      }
      return <NotFound />;
    }
    return <></>;
  }
  return <></>;
};

export default Vales;
